module.exports = __webpack_public_path__ + "img/imagens-capa.78ca8cee.webp";